export const PersonHeartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M10 10C12.4853 10 14.5 7.98528 14.5 5.5C14.5 3.01472 12.4853 1 10 1C7.51472 1 5.5 3.01472 5.5 5.5C5.5 7.98528 7.51472 10 10 10Z"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15 23H2C1.44772 23 0.994168 22.5506 1.05474 22.0016C1.55136 17.5005 5.36639 14 9.999 14C10.6869 14 11.3566 14.0771 12 14.2232"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.0726 15.5341L19 16.4737L19.9274 15.5341C20.2647 15.1924 20.7248 15 21.205 15C22.1963 15 23 15.8037 23 16.795V17.0898C23 17.6393 22.7836 18.1667 22.3976 18.5577L19.0573 21.942C19.0258 21.9739 18.9742 21.9739 18.9427 21.942L15.6024 18.5577C15.2164 18.1667 15 17.6393 15 17.0898V16.795C15 15.8037 15.8037 15 16.795 15C17.2752 15 17.7353 15.1924 18.0726 15.5341Z"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
